import UploadedPhoto from './UploadedPhoto';
import { Observable } from 'rxjs';

export default class ImageProcessingError<T> extends Error {
    constructor(
        readonly photo: UploadedPhoto,
        readonly originalError: unknown,
        readonly observable: Observable<T>,
        readonly operatorName: string,
    ) {
        super(`Error processing image ${photo.file.name} in ${operatorName}`);
    }
}
